import { LoginMode, SourceLayerEnum } from '@msc-b2c/interfaces/enums';
import { CompleteProfileResponse } from '@msc-b2c/interfaces/interfaces';

export const completeProfileResponseMock: CompleteProfileResponse = {
  token: 'eyJhbGciOiJIUzI1NiIsIn',
  crmasisId: 'CRM38951234',
  loginMode: LoginMode.FULL,
  name: 'John',
  surname: 'Wick',
  goldenId: '123456',
  _warnings: [
    {
      code: 'failed_linking_booking_to_customer',
      message:
        'CRM AS IS throws an error when attempting to link the customer with a booking number.',
      traceId: '73b309b81fd54d7fb43ead4052210959',
      errorId: '79b309b81fd54d7fb43ead4000010959',
      dateTime: '2024-04-23T10:00:00Z',
      source: {
        name: 'api-name',
        layer: SourceLayerEnum.API,
      },
      causes: [
        {
          code: 'invalid_value',
          message: "The value provided for field 'fieldName' is not valid.",
          field: 'fieldParent.fieldName',
          source: {
            name: 'api-name',
            layer: SourceLayerEnum.API,
          },
        },
      ],
    },
    {
      code: 'failed_linking_loyalty_card_number_to_customer',
      message:
        'CRM AS IS throws an error when attempting to link the customer with an existing Voyager Loyalty card number.',
      traceId: '73b309b81fd54d7fb43ead4052210959',
      errorId: '79b309b81fd54d7fb43ead4000010959',
      dateTime: '2024-04-23T10:00:00Z',
      source: {
        name: 'api-name',
        layer: SourceLayerEnum.API,
      },
      causes: [
        {
          code: 'invalid_value',
          message: "The value provided for field 'fieldName' is not valid.",
          field: 'fieldParent.fieldName',
          source: {
            name: 'api-name',
            layer: SourceLayerEnum.API,
          },
        },
      ],
    },
  ],
};
